export const liveOrdersColumnDefs = [
    {
        headerName: 'Time',
        field: 'matcher_time',
        width: 150
    },
    {
        headerName: 'ClordID',
        field: 'clordid',
        width: 110
    },
    {
        headerName: 'OSI Symbol',
        field: 'osi_symbol',
        width: 200
    },
    {
        headerName: 'OSI Root',
        field: 'symbol',
        width: 100
    },
    {
        headerName: 'UL Symbol',
        field: 'ul_symbol',
        width: 100
    },
    {
        headerName: 'Side',
        field: 'side',
        width: 80
    },
    {
        headerName: 'Price',
        field: 'price',
        type: 'price',
        width: 100
    },
    {
        headerName: 'Quantity',
        field: 'leaves_qty',
        type: 'number',
        width: 150
    },
    {
        headerName: 'MPID',
        field: 'mpid',
        width: 150
    },
    {
        headerName: 'MMID',
        field: 'mmid',
        width: 150
    },
    {
        headerName: 'SenderCompID',
        field: 'user_session_id',
        width: 150
    },
    {
        headerName: 'Customer/Firm',
        field: 'customer_firm',
        width: 150
    },
    {
        headerName: 'CMTA',
        field: 'clearing_firm',
        width: 150
    },
    {
        headerName: 'Clearing Number',
        field: 'clearing_num',
        width: 150
    },
    {
        headerName: 'Open/Close',
        field: 'openclose',
        width: 150
    },
    {
        headerName: 'Optional Data',
        field: 'optional_data',
        width: 150
    },
    {
        headerName: 'Order Type',
        field: 'order_type',
        width: 150
    },
    {
        headerName: 'TIF',
        field: 'tif',
        width: 150
    },
    {
        headerName: 'Exec Instruction',
        field: 'exec_inst',
        width: 150
    },
    {
        headerName: 'Routing Instruction',
        field: 'routing_inst',
        width: 150
    },
    {
        headerName: 'ExtendedExec Instruction',
        field: 'ext_exec_inst',
        width: 150
    },
    {
        headerName: 'Strike Price',
        field: 'strike',
        width: 150
    },
    {
        headerName: 'Expiration Date',
        field: 'exp_date',
        width: 150
    },
    {
        headerName: 'Put/Call',
        field: 'putcall',
        width: 150
    },
    {
        headerName: 'Security Type',
        field: 'security_type',
        width: 150
    }
];
